import { render } from "./EnableNotificationsPage.vue?vue&type=template&id=8ebb62e8"
import script from "./EnableNotificationsPage.vue?vue&type=script&lang=js"
export * from "./EnableNotificationsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__